module.exports = __webpack_public_path__ + "static/media/grin-tears.153da7ba.svg";